export default __webpack_public_path__ + "static/1024-px-python-logo-notext-svg@3x-e0b9e0735cd50146c8b6df0491e5e04b.png";